import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import LcSignsModel from './LcSignsModel';

const BASE = BaseModel.getApiBasePath() + '/api/v1/lcsigns/messages';

export default new class LcSignsMessagesModel {

    constructor() { }

    get(id) {
        return new Promise((resolve, reject) => {
            this.getAll()
                .then((data) => {
                    resolve(_.find(data, { id: id }));
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getAll(dateFrom = null, dateTo = null) {

        const filter = {
            lastMqttStamp: {
                $gte: dateFrom,
                $lte: dateTo
            }
        };

        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken(),
                    filter: filter
                }
            })
                .then((response) => {
                    LcSignsModel.getAll(true)
                        .then((ts) => {
                            let data = [];
                            response.data.map(async (child, idx) => {
                                let sign = _.find(ts, { serialNumber: child.serialNumber });
                                sign && sign.description
                                    ? data.push(Object.assign({}, child, { description: sign.description }))
                                    : data.push(Object.assign({}, child, { description: '' }));
                            })
                            resolve(data);
                        });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getLastMsg(serialNumber) {
        var filter = {
            where: {
                and: [{ serialNumber: serialNumber }]
            },
            limit: 1
        };
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken(),
                    filter: {
                        where: {
                            and: [{
                                serialNumber: serialNumber
                            }]
                        },
                        order: "createdAt DESC",
                        limit: 1
                    }
                }
            })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    create(data) {
        return new Promise((resolve, reject) => {
            axios.post(BASE, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            axios.delete(BASE + '/' + id, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    test(serialNumber, data) {
        return new Promise((resolve, reject) => {
            axios.post(BASE + '/' + serialNumber + '/test', data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    restart(serialNumber) {
        return new Promise((resolve, reject) => {
            axios.post(BASE + '/' + serialNumber + '/restart', null, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    update(serialNumber, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        return new Promise((resolve, reject) => {
            axios.put(BASE + '/' + serialNumber, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    message(serialNumber, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        return new Promise((resolve, reject) => {
            axios.post(BASE + '/' + serialNumber + '/message', data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/LcSignsMessagesModel.js